export enum BillingCode {
  F10_10 = 'F10_10',
  F10_20 = 'F10_20',
  F10_21 = 'F10_21',
  F10_90 = 'F10_90',
  F11_20 = 'F11_20',
  F12_20 = 'F12_20',
  F20_9 = 'F20_9',
  F25_9 = 'F25_9',
  F31_2 = 'F31_2',
  F31_4 = 'F31_4',
  F31_9 = 'F31_9',
  F31_81 = 'F31_81',
  F32_0 = 'F32_0',
  F32_0_PERIPARTUM = 'F32_0_PERIPARTUM',
  F32_1 = 'F32_1',
  F32_1_PERIPARTUM = 'F32_1_PERIPARTUM',
  F32_2 = 'F32_2',
  F32_2_PERIPARTUM = 'F32_2_PERIPARTUM',
  F32_4 = 'F32_4',
  F32_5 = 'F32_5',
  F32_9 = 'F32_9',
  F33_0 = 'F33_0',
  F33_1 = 'F33_1',
  F33_2 = 'F33_2',
  F33_3 = 'F33_3',
  F33_9 = 'F33_9',
  F33_41 = 'F33_41',
  F33_42 = 'F33_42',
  F34_1 = 'F34_1',
  F40_10 = 'F40_10',
  F41_0 = 'F41_0',
  F41_1 = 'F41_1',
  F41_9 = 'F41_9',
  F42_9 = 'F42_9',
  F43_0 = 'F43_0',
  F43_10 = 'F43_10',
  F43_20 = 'F43_20',
  F43_21 = 'F43_21',
  F43_22 = 'F43_22',
  F43_23 = 'F43_23',
  F43_81 = 'F43_81',
  F50_9 = 'F50_9',
  F53_0 = 'F53_0',
  F60_9 = 'F60_9',
  F84_0 = 'F84_0',
  F84_5 = 'F84_5',
  F90_0 = 'F90_0',
  F90_1 = 'F90_1',
  F90_2 = 'F90_2',
}

export const BILLING_CODES_REQUIRED_MESSAGE = 'At least one diagnosis code is required'

export const DEPRECATED_BILLING_CODES: Set<BillingCode> = new Set([
  BillingCode.F10_10,
  BillingCode.F10_20,
  BillingCode.F10_21,
  BillingCode.F10_90,
  BillingCode.F11_20,
  BillingCode.F12_20,
  BillingCode.F20_9,
  BillingCode.F25_9,
  BillingCode.F31_2,
  BillingCode.F31_4,
  BillingCode.F32_4,
  BillingCode.F32_5,
  BillingCode.F33_3,
  BillingCode.F33_41,
  BillingCode.F33_42,
  BillingCode.F50_9,
  BillingCode.F84_0,
  BillingCode.F84_5,
])

type BillingCodeName = {
  short: string
  long: string
}

export const BILLING_CODE_NAMES: Record<BillingCode, BillingCodeName> = {
  F10_10: {
    short: 'alco abuse unspec',
    long: 'Alcohol Use Disorder',
  },
  F10_20: {
    short: 'alco dep uncomp',
    long: 'Alcohol dependence, uncomplicated',
  },
  F10_21: {
    short: 'alco dep in rem',
    long: 'Alcohol Dependence, in remission',
  },
  F10_90: {
    short: 'alco use unspec',
    long: 'Alcohol use, unspecified, uncomplicated',
  },
  F11_20: {
    short: 'opio dep uncomp',
    long: 'Opioid dependence, uncomplicated',
  },
  F12_20: {
    short: 'canna dep uncomp',
    long: 'Cannabis Use Disorder',
  },
  F20_9: {
    short: 'schizophr unspec',
    long: 'Schizophrenia, unspecified',
  },
  F25_9: {
    short: 'schizoaf dis unspec',
    long: 'Schizoaffective disorder, unspecified',
  },
  F31_2: {
    short: 'bp manic',
    long: 'Bipolar disorder, current episode manic, severe, with psychotic features',
  },
  F31_4: {
    short: 'bp sev dep',
    long: 'Bipolar disorder, current episode depressed, severe, with psychotic features',
  },
  F31_9: {
    short: 'bp unspec',
    long: 'Bipolar Disorder, unspecified',
  },
  F31_81: {
    short: 'bp 2',
    long: 'Bipolar II Disorder',
  },
  F32_0: {
    short: 'mdd 1 ep mild',
    long: 'Major Depressive Disorder, single episode, mild',
  },
  F32_0_PERIPARTUM: {
    short: 'mdd 1 ep mild peri',
    long: 'Major Depressive Disorder, single episode, mild with peripartum onset',
  },
  F32_1: {
    short: 'mdd 1 ep mod',
    long: 'Major Depressive Disorder, single episode, moderate',
  },
  F32_1_PERIPARTUM: {
    short: 'mdd 1 ep mod peri',
    long: 'Major Depressive Disorder, single episode, moderate with peripartum onset',
  },
  F32_2: {
    short: 'mdd 1 ep sev',
    long: 'Major Depressive Disorder, single episode, severe without psychotic features',
  },
  F32_2_PERIPARTUM: {
    short: 'mdd 1 ep sev peri',
    long: 'Major Depressive Disorder, single episode, severe with peripartum onset',
  },
  F32_4: {
    short: 'mdd 1 ep part rem',
    long: 'Major depressive disorder, single episode, in partial remission',
  },
  F32_5: {
    short: 'mdd 1 ep full rem',
    long: 'Major depressive disorder, single episode, in full remission',
  },
  F32_9: {
    short: 'mdd 1 ep unspec',
    long: 'Major Depressive Disorder, single episode, unspecified',
  },
  F33_0: {
    short: 'mdd recur mild',
    long: 'Major Depressive Disorder, recurrent, mild',
  },
  F33_1: {
    short: 'mdd recur mod',
    long: 'Major Depressive Disorder, recurrent, moderate',
  },
  F33_2: {
    short: 'mdd recur sev',
    long: 'Major Depressive Disorder, recurrent, severe without psychotic symptoms',
  },
  F33_3: {
    short: 'mdd recur sev w psych sym',
    long: 'Major depressive disorder, recurrent, severe with psychotic symptoms',
  },
  F33_9: {
    short: 'mdd recur unspec',
    long: 'Major Depressive Disorder, recurrent, with unspecified severity',
  },
  F33_41: {
    short: 'mdd recur part rem',
    long: 'Major Depressive Disorder, recurrent, in partial remission',
  },
  F33_42: {
    short: 'mdd recur full rem',
    long: 'Major Depressive Disorder, Recurrent, in Full Remission',
  },
  F34_1: {
    short: 'dysthym dis',
    long: 'Persistent Depressive Disorder',
  },
  F40_10: {
    short: 'social phobia',
    long: 'Social Phobia, unspecified',
  },
  F41_0: {
    short: 'panic dis',
    long: 'Panic Disorder',
  },
  F41_1: {
    short: 'gen anx dis',
    long: 'Generalized Anxiety Disorder',
  },
  F41_9: {
    short: 'anx dis unspec',
    long: 'Unspecified Anxiety Disorder',
  },
  F42_9: {
    short: 'ocd unspec',
    long: 'Obsessive-Compulsive Disorder, unspecified',
  },
  F43_0: {
    short: 'act stress react',
    long: 'Acute Stress Reaction',
  },
  F43_10: {
    short: 'ptsd',
    long: 'Post Traumatic Stress Disorder',
  },
  F43_20: {
    short: 'adj dis unspec',
    long: 'Adjustment Disorder, unspecified',
  },
  F43_21: {
    short: 'adj dis w depr',
    long: 'Adjustment Disorder with depressed mood',
  },
  F43_22: {
    short: 'adj dis w anx',
    long: 'Adjustment Disorder with anxiety',
  },
  F43_23: {
    short: 'adj dis w anx depr',
    long: 'Adjustment Disorder with mixed anxiety and depression',
  },
  F43_81: {
    short: 'prol grief',
    long: 'Prolonged Grief Disorder',
  },
  F50_9: {
    short: 'eat dis unspec',
    long: 'eating disorder, unspecified',
  },
  F53_0: {
    short: 'pos depr',
    long: 'Postpartum Depression',
  },
  F60_9: {
    short: 'per dis',
    long: 'Personality Disorder, unspecified',
  },
  F84_0: {
    short: 'aut spe dis',
    long: 'Autistic disorder',
  },
  F84_5: {
    short: 'asp syn',
    long: "Asperger's Syndrome",
  },
  F90_0: {
    short: 'adhd pre inat',
    long: 'Attention-Deficit/Hyperactivity Disorder, predominantly inattentive presentation',
  },
  F90_1: {
    short: 'adhd pre hyp',
    long: 'Attention-Deficit Hyperactivity Disorder, predominantly hyperactive type',
  },
  F90_2: {
    short: 'adhd comb',
    long: 'Attention-Deficit Hyperactivity Disorder, combined type',
  },
} as const
